<template>
  <div class="serp-tours__container">
    <div class="serp-tours__content">
      <div class="serp-tours__reset" v-if="showReset">
        <div
          v-for="{ code, label } in changedFilters"
          :key="code"
          class="serp-tours__reset-item"
        >
          <yt-pill removable @remove="resetFilter(code)">
            {{ label }}
          </yt-pill>
        </div>
        <div class="serp-tours__reset-all-desktop">
          <yt-pill
            :disabled="!showReset"
            removable
            @remove="$refs.filters.resetFilters()"
          >
            <span>
              {{ $t(`serp.tours.${showReset ? "reset" : "no"}Filters`) }}
            </span>
            <span v-if="changedFilters.length">
              ({{ changedFilters.length }})
            </span>
          </yt-pill>
        </div>
        <div
          v-if="showReset"
          class="serp-tours__reset-all"
          @click="$refs.filters.resetFilters()"
        >
          <span class="font-text" v-text="$t('serp.tours.resetFilters')"></span>
          <Icon icon="close" color="#1f1f1f" />
        </div>
      </div>

      <div class="serp-tours__sort" v-show="total">
        <div class="serp-tours__sort-container" :class="{'_left': showHorizontalView}">
          <div class="serp-tours__total font-text">
            <div
              class="serp-tours__total-mobile"
              v-text="$t('serp.tours.foundTours.mobile', { total })"
            ></div>
            <div
              class="serp-tours__total-desktop"
              v-text="$t('serp.tours.foundTours.desktop', { total })"
            ></div>
          </div>
          <div class="serp-tours__sort__desktop">
            <div class="serp-tours__sort__mobile font-text">
              <div
                class="serp-tours__sort__mobile__title font-text"
                v-text="$t('serp.tours.sort')"
              ></div>
              <div class="serp-tours__sort__mobile__sort-wrapper">
                <div
                  class="serp-tours__sort__mobile__sort font-text"
                  :class="{ active: showSortDropdown }"
                  v-text="selectedSorting.label"
                  @click.stop="showSortDropdown = !showSortDropdown"
                ></div>
                <div class="serp-tours__sort__mobile__sort-arrow"></div>
              </div>
            </div>

            <div
              ref="dropdown"
              class="serp-tours__sort__dropdown"
              :class="{ active: showSortDropdown }"
            >
              <div
                class="serp-tours__sort__button font-text"
                :key="i"
                v-for="(btn, i) in sortButtons"
                v-text="btn.label"
                @click.stop="selectSort(i)"
              ></div>
            </div>
          </div>
        </div>

        <div class="serp-tours__view" v-if="!isMobile && showHorizontalView">
          <div class="serp-tours__view-type" :class="{'active' : getSerpViewTypeList}" @click="setSerpView(true, true)">
            <icon icon="list" :color="getSerpViewTypeList ? 'black' : 'secondary'"/>
            <span>{{$t("serp.tours.view.list")}}</span>
          </div>
          <div class="serp-tours__view-type" :class="{'active' : !getSerpViewTypeList}" @click="setSerpView(false, true)">
            <icon icon="tile" :color="!getSerpViewTypeList ? 'black' : 'secondary'"/>
            <span>{{$t("serp.tours.view.tile")}}</span>
          </div>
        </div>
      </div>

        <Filters
          v-show="isShowFilter"
          ref="filters"
          class="serp-tours__filters"
          :sortQuery="sortQuery"
          @closeFilter="isShowFilter = false"
          @loadedFacets="onLoadedFacets($event)"
          @changed-filters="changedFilters = $event"
          @setQuickFilters="$emit('setQuickFilters', $event)"
          @setParticipants="participants = $event">

          <div slot="banner">
            <BannerSerp
              v-show="isShowFilter"
              v-for="(banner) in firstBanners"
              :key="banner.id"
              :image-src="banner.imageSrc"
              :link="banner.link"
              :position="banner.position"
            />
          </div>
        </Filters>
      <div class="serp-tours__result" :class="{ empty: !total }" ref="results">
        <div
          class="serp-tours-seo-content"
          v-if="isCashbackPage && serpSeoText"
        >
          <div
            class="serp-tours-seo-content__header"
            @click="moreSeoTextDropdown"
          >
            {{ $t("serp.seo.actionConditions") }}
          </div>
          <div
            class="serp-tours-seo-content__text"
            :class="{ active: seoTextOpened }"
            v-html="serpSeoText"
          ></div>
        </div>
        <BannerSerp
          v-show="filteredBanners.length && showSerpBanner(banner.position)"
          v-for="(banner) in filteredBanners"
          :key="banner.id"
          :image-src="banner.imageSrc"
          :link="banner.link"
          :position="banner.position"
          :is-mobile="banner.isImageForMobile"
        />
        <div class="serp-banner__double" v-show="doubleBanners.length">
          <BannerSerp
            v-for="(banner) in doubleBanners"
            :key="banner.id"
            :image-src="banner.imageSrc"
            :link="banner.link"
            :position="banner.position"
          />
        </div>
          <template v-if="total && !getSerpViewTypeList">
              <TourCard
                class="serp-tours__result__item"
                v-for="(tour, id) in filteredTours"
                :tour="tour"
                :lazy-image="tour.imageLazy"
                :query="queryToString(toursQuery)"
                :is-super-expert="isSuperExpert(tour.expert?.id)"
                :loading="
                (loadingTours && !skip) || (loadingTours && id + 1 > skip)
              "
                :participants="participants"
                :key="tour.id"
                :location-info="locationInfo"
                @init-topsort-id="initTopsortUid()"
              />
          </template>
          <template v-if="total && getSerpViewTypeList">
              <TourCardHorizontal
                class="serp-tours__result__item"
                v-for="(tour, id) in filteredTours"
                :index="id+1"
                :tour="tour"
                :lazy-image="tour.imageLazy"
                :query="queryToString(toursQuery)"
                :is-super-expert="isSuperExpert(tour.expert?.id)"
                :loading="
                (loadingTours && !skip) || (loadingTours && id + 1 > skip)
              "
                :location-info="locationInfo"
                :participants="participants"
                :key="tour.id"
                @init-topsort-id="initTopsortUid()"
              />
          </template>
        <div v-if="!total" class="serp-tours__result__empty">
          <div
            class="serp-tours__result__empty__header font-h0"
            v-text="$t('serp.tours.nothingFound')"
          ></div>

          <div
            class="serp-tours__result__empty__subheader font-h2"
            v-text="$t('serp.tours.tryToChangeFilters')"
          ></div>
          <div class="serp-tours__result__empty__buttons">
            <Button
              class="serp-tours__result__empty__btn"
              :color="'white'"
              :text="$t('serp.tours.resetFilters')"
              @click="$refs.filters.resetFilters()"
            />
            <Button
              class="serp-tours__result__empty__btn"
              v-if="isExclusiveProduct"
              :color="'gray'"
              :text="'Искать среди многодневных'"
              @click="menuTabClickHandler('multiDays')"
            />
          </div>
        </div>
      </div>

      <div class="serp-tours__show-more" v-show="isShowMore">
        <Button
          class="serp-tours__show-more__btn"
          :color="'green'"
          :text="$t('serp.tours.showMore')"
          @click="loadMoreTours()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Icon from "@/components/icons/index.vue";
import Button from "@/components/ui-kit/button/index.vue";
import BannerSerp from "@/components/templates/banner-serp/index.vue";
import YtPill from "@/components/ui-kit/yt-pill/index.vue";
import TourCard from "@/components/ui-kit/tour-card/index.vue";
import TourCardHorizontal from "@/components/ui-kit/tour-card-horizontal/index.vue"
import Filters from "./filters.vue";
import { abTestController } from "@/plugins/abtest";
import { mapMutations, mapState } from "vuex";
import dataCollector from "@/plugins/dataCollector/index";
import helper from "@/mixins/helper.js";
import { useSerp } from "@/state/serp";
import { useQueryString } from "@/utils/query-string";
import "@/plugins/dataCollector/index";
import "lazysizes";
import { ytEvents } from "@/plugins/analytics";
import { debounce } from "debounce";
import { initTopsort, initTopsortUserId } from "@/assets/js/utils/topsort-analytics";
import {axiosLocations} from "@/services/scopes/axios-locations";

const popularRanking = abTestController.getSegment("NYRANK") === "B" ? "rank_calculated" : "rank";

export default {
  name: "tours",
  mixins: [helper],
  components: {
    Icon,
    Button,
    YtPill,
    Filters,
    TourCard,
    BannerSerp,
    TourCardHorizontal
  },
  data() {
    return {
      showSortDropdown: false,
      isShowFilter: false,
      tours: null,
      total: 0,
      recommendedTotal: 0,
      sponsoredTotal: 0,
      filtersQuery: {},
      participants: 1,
      sortButtons: [
        {
          label: this.$t("serp.tours.sortBy.popular"),
          sortBy: popularRanking,
          sortDir: "desc",
          selected: abTestController.getSegment("ml_playground") !== "B",
        },
        {
          label: this.$t("serp.tours.sortBy.recommended"),
          sortBy: "recommended",
          sortDir: "desc",
          selected: abTestController.getSegment("ml_playground") === "B",
        },
        {
          label: this.$t("serp.tours.sortBy.new"),
          sortBy: "first_date_publish",
          sortDir: "desc",
          selected: false,
        },
        {
          label: this.$t("serp.tours.sortBy.closest"),
          sortBy: "nearest_date",
          sortDir: "asc",
          selected: false,
        },
        {
          label: this.$t("serp.tours.sortBy.priceLow"),
          sortBy: "price",
          sortDir: "asc",
          selected: false,
        },
        {
          label: this.$t("serp.tours.sortBy.priceHigh"),
          sortBy: "price",
          sortDir: "desc",
          selected: false,
        },
        {
          label: this.$t("serp.tours.sortBy.discount"),
          sortBy: "discount",
          sortDir: "desc",
          selected: false,
        },
      ],
      take: 20,
      skip: 0,
      guid: "",
      changedFilters: [],
      controller: null,
      signal: null,
      seoTextOpened: false,
      excluded_front_tours: new Set(),
      bannersSerp: [],
      serpViewTypeList: false,
      isMobile: false,
      recommendationsLoaded: false,
      showHorizontalView: true,
      locationInfo: []
    };
  },
  watch: {
    isShowFilter(val) {
      if (val) {
        this.$nextTick(() => this.$refs.filters.refresh());
      }
    },
    sortQuery() {
      this.debounceLoadTours();
    },
    async location (val) {
      if(val) {
        if(val[0].type == "location") {
          this.locationInfo = await this.getLocationInfo(val[0].id);
        }
        else {
          this.locationInfo = [];
        }
      }
      else {
        this.locationInfo = [];
      }
    }
  },
  computed: {
    ...mapState({
      currency: (state) => state.currency.currency,
      language: (state) => state.language.language,
      loading: (state) => state.serp.loading,
      loadingTours: (state) => state.serp.loadingTours,
      //ssrTours: (state) => state.serp.serpTours.tours?.data?.items,
      ssrTours: (state) => state.serp.serpTours.tours?.data?.items.filter(item => item.id),
      ssrTotal: (state) => state.serp.serpTours.tours?.data?.total,
      showReset: (state) => state.serp.showReset,
      query: (state) => state.serp.serpQuery.query,
      isUserLoggedIn: (state) => state.user.user.isLoggedIn,
      countryCode: (state) => state.country.countryCode,
      serpSeoText: (state) => state.serp.serpSeoText.seoText,
      isCashbackPage: (state) => state.serp.isCashbackPage.isCashbackPage,
      facets: (state) => state.serp.serpTours.facets.data,
      productType: (state) => state.serp.productType,
      ssrBannersSerp: (state) => state.serp.serpTours.bannersSerp?.data,
      analyticsParam: (state) => state.serp.analyticsParam,
      locationData: (state) => state.serp.locationInfo,
      location: (state) => state.serp.location
    }),

    isExclusiveProduct() {
      return this.productType === 'exclusive';
    },
    filteredTours() {
      if (this.tours) {
        const tours = this.tours.filter((el) => el);

        if (this.loadingTours && this.skip) {
          return tours.concat(tours.slice(0, 20));
        }
        tours.forEach(function (tour) {
          tour.imageLazy = true;
        });
        tours[0].imageLazy = false;
        return tours;
      }

      return [];
    },
    isShowMore() {
      return this.total > this?.tours?.length;
    },
    selectedSorting() {
      return this.sortButtons.find(({ selected }) => selected) || this.sortButtons[0];
    },

    toursQuery() {
      return {
        ...this.filtersQuery,
        ...this.userQuery,
        ...this.sortQuery,
        take: this.take,
        skip: this.skip,
      };
    },
    loadMoreToursQuery() {
      return {
        ...this.toursQuery,
        ...this.excludedQuery,
        ...this.excludedFrontQuery,
      };
    },

    userQuery() {

      const query = {};
      if (!vueOptions.ssr) {
        let userId = dataCollector.getCookie("BX_USER_ID");
        let userType = "guest";

        if (this.isUserLoggedIn) {
          userId = dataCollector.getCookie("BITRIX_SM_USER_BX_ID");
          userType = "user";
        }

        if (!userId) {
          userId = dataCollector.guid();
          let date = new Date(Date.now() + 365 * 86400000);
          dataCollector.setCookie("BX_USER_ID", userId, {
            expires: date.toUTCString(),
          });
        }

        query.user = {
          id: userId,
          type: userType,
        };

        query.search_guid = this.guid;
      }

      return query;
    },
    sortQuery() {
      return {
        sort_by: this.selectedSorting.sortBy,
        sort_dir: this.selectedSorting.sortDir,
      };
    },
    excludedQuery() {
      const query = {};

      if (this.selectedSorting.sortBy === "rank" && this.tours) {
        query.excluded_tours = [];

        this.tours.forEach((tour) => {
          if (tour.is_latest) {
            query.excluded_tours.push(tour.id);
          }
        });
      }

      return query;
    },
    excludedFrontQuery() {
      const query = {
        excluded_front_tours: [],
      };

      return [...this.excluded_front_tours].forEach((acc, el) => {
        query.excluded_front_tours.push(el);
      });
    },
    recommendedToursQuery() {
      return {
        ...this.filtersQuery,
        ...this.userQuery,
        currency: this.currency.id.toLowerCase(),
        lang: this.language.id,
        take: Math.floor(+this.tours.length * 0.3),
        sort_by: "recommended",
        sort_dir: "desc",
        skip: 0,
      };
    },
    listingToursQuery() {
      const query = {};
      const types = this.toursQuery['types[0]'];
      const loc = {
        id: this.toursQuery["loc[0][id]"],
        type: this.toursQuery["loc[0][type]"],
      };

      let pathName = vueOptions.ssr ? context.url : window.location.pathname;

      const isTypeListing = pathName.indexOf("/type/") !== -1 && !loc?.id;
      const isMainListing = !isTypeListing && !loc?.id;
      const isLocationListing = !isTypeListing && loc?.id;
      const isSpecial = pathName.indexOf("/specials/") !== -1;

      if (isSpecial) {
        let arr = pathName.split('/');
        query.listingType = "specials";
        query.elementId = arr[3];
        return query;
      }

      if (isMainListing) {
        query.listingType = "main-listing";
      } else if (isLocationListing && !this.toursQuery["loc[1][id]"]) {
        query.listingType = loc?.type;
        query.elementId = loc?.id;
      } else if (isTypeListing && !this.toursQuery["types[1]"]) {
        query.listingType = "type";
        query.elementId = types;
      }

      return query;
    },
    doubleBanners() {
      let banners = this.bannersSerp?.filter(banner => {
        return banner.position >= 4 && !banner.isImageForMobile;
      });

      if (banners.length !== 2) {
        return false;
      }
      return banners;
    },
    filteredBanners() {
      return this.bannersSerp?.filter(banner => {
        return banner.position > 1 && banner.position < 4
          || banner.position >= 4 && banner.isImageForMobile;
      });
    },
    firstBanners() {
      return this.bannersSerp?.filter(banner => {
        return banner.position === 1;
      });
    },
    getSerpViewTypeList () {

      if(this.isMobile) {
        return false;
      }
      return this.serpViewTypeList;
    },

  },
  methods: {
    ...mapMutations("serp", [
      "setLoadingTours",
      "setFavorite",
      "selectLocation",
      "selectDates",
      "setIsOnlyExclusive",
      "setProductType",
    ]),
    abtestHorizontalViewType () {
      this.showHorizontalView = abTestController.getSegment(16514) === "B";
    },
    setCountryCode() {
      this.$store.dispatch('country/setCountryCode');
    },
    async getLocationInfo(locId) {
      if(locId) {
        let data = await axiosLocations.getLocationInfo(locId);
        if(data.data.success) {
          return data.data.data;
        }
        else {
          return [];
        }
      }
      else {
        return [];
      }
    },
    async setIsLocationInfo() {

      let pathName = vueOptions.ssr ? context.url : window.location.pathname;
      const isLocation = pathName.indexOf("/location/") !== -1;

      if(isLocation) {
        if(vueOptions.ssr) {
          this.locationInfo = this.locationData;
        }
        else {
          const locId =  this.toursQuery["loc[0][id]"];
          this.locationInfo = await this.getLocationInfo(locId)

        }
      }
      else {
        this.locationInfo = [];
      }

    },
    isSuperExpert(expertId = 0) {
      let superExperts = [
        // 49249,
        // 69962,
        // 13248,
        // 81700,
        // 89629,
        // 71912,
        // 14784,
        // 12648,
        // 84022,
        // 22285,
      ];

      return superExperts.includes(expertId);
    },
    showSerpBanner(position){
      if(this.serpViewTypeList){
        return position !== 2;
      }
      return true
    },
    initTopsortUid() {
      initTopsortUserId()
    },
    setSerpView(value, trackEvent = false) {
      this.serpViewTypeList = value;
      if(trackEvent)
      {
        ytEvents.track(
          "Tour list",
          "Click Change View",
          this.productType,
          {
            type: this.serpViewTypeList ? "List" : "Tile"
          });
      }

    },
    queryToString(query) {
      const { stringifyQuery } = useQueryString();

      return stringifyQuery(query)
    },
    debounceLoadTours() {
      debounce(this.loadTours(), 150)
    },
    async loadTours() {
      const { stringifyQuery } = useQueryString();
      const { getToursSearch, getBannersSerp } = useSerp();

      if (typeof this.toursQuery?.lang === 'undefined') {
        return;
      }

      try {
        const query = stringifyQuery(this.toursQuery);
        const {
          items,
          total,
          metadata: meta,
        } = await getToursSearch(query);

        if (items && items?.length) {
          let filteredItems = items;
          const itemsLength = filteredItems.length;
          let itemsNewLength = 0;
          if (this.isIosApp) {
            filteredItems = filteredItems.filter((el) => {
              return !(
                el.regions.includes("Крым") ||
                el.title.toLowerCase().includes("крым")
              );
            });

            itemsNewLength = itemsLength - filteredItems.length;
          }

          if (filteredItems && filteredItems?.length) {
            this.tours = filteredItems.map((el) => ({
              ...el,
              recommended: false,
              meta,
            }));
            this.total = total - itemsNewLength;
          } else {
            this.tours = [];
            this.total = 0;
          }

          if (!vueOptions.ssr) {
            this.trackSearchRequest();
          }
          if (
            this.selectedSorting.sortBy === popularRanking &&
            abTestController.getSegment("ml_playground") !== "A"
          ) {
            if (this.signal) {
              this.controller.abort();
            }
            this.loadRecommendedTours();
            this.loadTourPromoListing();
          }
        } else {
          if (!vueOptions.ssr && total !== undefined) {
            // Отправляем событие, что туров не нашли только если не было ошибки при запросе, т.е. если в ответ пришел total
            this.trackNotfoundRequest();
          }
          this.tours = [];
          this.total = 0;
        }

        this.bannersSerp = await getBannersSerp(query);
      } catch (err) {
        console.log(err);
      } finally {

        this.abtestHorizontalViewType();
        this.setSerpView(this.showHorizontalView);
        this.setLoadingTours(false);
      }
    },
    async loadMoreTours() {
      const { stringifyQuery } = useQueryString();
      const { getToursSearch } = useSerp();

      this.setLoadingTours(true);
      this.skip = this.skip + 20;

      try {
        const queryParser = stringifyQuery(this.loadMoreToursQuery);
        const { items } = await getToursSearch(queryParser);

        if (items.length) {
          let filteredItems = items.filter((el) => {
            return this.tours.findIndex(({ id }) => id === el.id) === -1;
          });

          const itemsLength = filteredItems.length;
          if (this.isIosApp) {
            filteredItems = filteredItems.filter((el) => {
              return !(
                el.regions.includes("Крым") ||
                el.title.toLowerCase().includes("крым")
              );
            });

            this.total = this.total - (itemsLength - filteredItems.length);
          }
          this.tours.push(...filteredItems);
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.setLoadingTours(false);
      }
    },
    async loadRecommendedTours() {
      const { stringifyQuery } = useQueryString();
      const { getToursSearch } = useSerp();

      this.controller = new AbortController();
      this.signal = this.controller.signal;
      this.recommendationsLoaded = false;

      try {
        const queryParser = stringifyQuery(this.recommendedToursQuery);
        const { items, metadata } = await getToursSearch(
          queryParser,
          this.signal
        );

        this.signal = null;

        let filteredItems = items;

        if (this.isIosApp) {
          filteredItems = filteredItems.filter((el) => {
            return !el.regions.includes("Крым");
          });
        }
        if(!filteredItems) {
          return;
        }
        const sponsoredIndexes = this.tours.reduce((indexes, tour, index) => {
          if (tour.sponsored === true) {
            indexes.push(index);
          }
          return indexes;
        }, []);

        const maxSponsoredIndex = Math.max(...sponsoredIndexes);
        filteredItems.forEach((item) => {
          const foundIndex = this.tours.findIndex(
            (tour) => tour.id === item.id
          );
          if (foundIndex !== -1) {
            this.tours[foundIndex].recommended = true;
            this.tours[foundIndex].meta = metadata;
          } else {

            let index = Math.floor(
              Math.random() * (this.tours.length - 0 + 1)
            );

            if (index <= maxSponsoredIndex) {
              index = maxSponsoredIndex + 1;
            }

            this.tours.splice(index, 0, {
              ...item,
              recommended: true,
              meta: metadata,
            });
            this.excluded_front_tours.add(item.id);
          }
        });
      } catch (error) {
        console.error(error);
      }

      this.recommendationsLoaded = true;
    },
    async loadTourPromoListing() {
      const { stringifyQuery } = useQueryString();
      const { getListingTours } = useSerp();
      if (Object.keys(this.listingToursQuery)) {
        try {
          this.controller = new AbortController();
          this.signal = this.controller.signal;

          const query = this.getTourPromoListingQuery([]);
          const queryParser = stringifyQuery(query);
          const { items } = await getListingTours(queryParser);

          this.signal = null;

          let listingIndexStart = 0;
          let promoPostions = [0, 2, 6, 8];

          if (items) {
            items.forEach((item) => {
              if (listingIndexStart > 3) {
                return;
              }
              const foundIndex = this.tours.findIndex(
                (tour) => tour.id === item.id
              );

              if (foundIndex !== -1) {
                this.tours.splice(foundIndex, 1);
              } else {
                this.excluded_front_tours.add(item.id);
              }

              let index = promoPostions[listingIndexStart];
              listingIndexStart++;

              if (typeof index !== "undefined") {
                this.tours.splice(index, 0, {
                  ...item,
                  sponsored: true,
                  meta: { sponsored: true },
                });
              }
            });

            initTopsort(this.analyticsParam?.topsort?.eventToken ?? '');
          }
        } catch (error) {
          console.error(error);
        }
      }
    },
    showFilter() {
      this.isShowFilter = true;
    },
    onLoadedFacets(query) {
      this.guid = dataCollector.guid();
      this.filtersQuery = query;
      this.skip = 0;
      this.debounceLoadTours();
    },
    selectSort(id) {
      if (this.sortButtons[id].selected) {
        return;
      }

      this.guid = dataCollector.guid();
      this.skip = 0;
      this.setLoadingTours(true);
      this.showSortDropdown = false;
      this.sortButtons.forEach((el, i) => {
        el.selected = i === id;
      });
    },
    getTourPromoListingQuery(listingTours) {
      const query = {
        ...this.filtersQuery,
        ...this.userQuery,
        ids: [],
        currency: this.currency.id.toLowerCase(),
        lang: this.language.id,
        skip: 0,
      };

      if (listingTours) {
        query.ids = listingTours;
        query.take = listingTours.length < 7 ? 7 : listingTours.length;
      }

      return query;
    },
    trackNotfoundRequest() {
      ytEvents.track("Tour list", "Show Nothing found", this.productType);
    },
    trackSearchRequest() {
      if (typeof youtravel.DataCollector !== "undefined") {
        youtravel.DataCollector.trackEvent(
          "Tour list",
          "Send search request",
          {
            filter: this.toursQuery,
            additional: {
              lang: this.language.id,
              productType: this.productType,
              total: this.total,
              datetime: new Date().toISOString(),
              country_code: this.countryCode,
            },
          }
        );
      }
      ytEvents.track("Tour list", "Send Search request", this.productType, {
        type: this.productType,
        total: this.total
      });
    },
    resetFilter(code) {
      if (code === "location") {
        this.selectLocation(null);
        return;
      }

      if (code === "dates") {
        this.selectDates(null);
        return;
      }

      this.$refs.filters.resetFilter(code);
    },
    moreSeoTextDropdown() {
      this.seoTextOpened = !this.seoTextOpened;
    },
    menuTabClickHandler(type) {
      this.setProductType(type);
      this.setIsOnlyExclusive(type === "exclusive");
    },
    setIsMobile() {
      if (vueOptions.ssr) {
        this.isMobile = fakeWindow.innerWidth >= 1024;
      }
      else {
        this.displayWidth = document.documentElement.clientWidth;
        this.isMobile = this.displayWidth < 768;
      }
    },
  },
  beforeDestroy() {
    fakeWindow.removeEventListener("click");
    fakeWindow.removeEventListener("resize");
    fakeWindow.removeEventListener("lazybeforeunveil");
    fakeWindow.removeEventListener("scroll");
  },
  mounted() {
    this.setIsMobile();
    fakeWindow.addEventListener("resize", this.setIsMobile);
  },
  created() {
    this.setCountryCode();
    this.abtestHorizontalViewType();
    if(vueOptions.ssr) {
      this.setSerpView(this.showHorizontalView);
      this.setIsLocationInfo();
    }
    if (this.ssrTours && this.ssrTours.length) {
      this.tours = this.ssrTours;
      this.total = Array.isArray(this.ssrTotal)
        ? this.ssrTotal[0]
        : this.ssrTotal;
    }

    if (this.ssrBannersSerp && this.ssrBannersSerp.length) {
      this.bannersSerp = this.ssrBannersSerp;
    }

    if (!vueOptions.ssr) {
      this.setSerpView(this.showHorizontalView);
      this.controller = new AbortController();

      history.scrollRestoration = "manual";
      fakeWindow.scrollTo(0, 0);

      if (fakeWindow.innerWidth >= 1024) {
        this.isShowFilter = true;
      }

      if (this.query.sort_by) {
        this.sortButtons.forEach((el) => {
          if (this.query.sort_by === "price" && el.sortBy === "price") {
            el.selected = el.sortDir === this.query.sort_dir;
          } else if (this.query.sort_by === 'rank_no_resident') {
            el.sortBy = this.query.sort_by;
          } else {
            if (this.query.sort_by === el.sortBy) {
              el.sortDir = this.query.sort_dir;
              el.selected = true;
            } else {
              el.selected = false;
            }
          }
        });
      }

      fakeWindow.addEventListener("click", (e) => {
        if (!this.$refs.dropdown.contains(e.target)) {
          this.showSortDropdown = false;
        }
      });
      fakeWindow.addEventListener("resize", () => {
        if (fakeWindow.innerWidth >= 1024) {
          this.isShowFilter = true;
        }
      });
      fakeWindow.addEventListener("lazybeforeunveil", (e) => {
        //@TODO Вынести в отдельный обработчик на глобальном уровне
        if (
          typeof youtravel.DataCollector !== "undefined" &&
          !vueOptions.ssr
        ) {
           let tourEl = this.getSerpViewTypeList ? e.target.closest(".tour-card-horizontal") : e.target.closest(".tour-card");
           if(tourEl) {
             youtravel.DataCollector.trackEvent(
               "Tour list",
               "View Tour item",
               {
                 tour_id: tourEl.dataset.id || "",
                 list: tourEl.dataset.list || "",
                 filter: this.toursQuery,
                 meta: tourEl.dataset.meta ? JSON.parse(tourEl.dataset.meta) : {},
                 additional: {},
               }
             );
           }
        }
      });
      fakeWindow.addEventListener("scroll", () => {
        if (
          fakeWindow.scrollY + fakeWindow.innerHeight >=
            this.$refs.results.scrollHeight &&
          !this.loadingTours &&
          this.isShowMore
        ) {
          this.loadMoreTours();
        }
      });
    }
  },

};
</script>

<style lang="scss" scoped>
.serp-tours {
  &__container {
    background: var.$gray-light;
    padding: 20px 16px;
  }

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
    position: relative;
  }

  &__reset {
    grid-area: reset;
    align-self: start;
    display: grid;
    padding-bottom: 16px;
    grid-auto-flow: column;
    overflow-x: auto;
    overflow-y: hidden;
    width: 100%;

    &::-webkit-scrollbar {
      display: none;
    }

    &-item {
      flex-shrink: 0;
      margin-right: 8px;
    }

    &-all {
      display: flex;
      align-items: center;
      cursor: pointer;
      flex-shrink: 0;
      margin-left: 10px;
      white-space: nowrap;

      &-desktop {
        display: none;
      }

      > svg {
        width: 8px;
        height: 8px;
        flex-shrink: 0;
        margin-left: 10px;
      }
    }
  }

  &__sort {
    grid-area: sort;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;

    &-container {
      display: flex;
      grid-gap: 24px;
      width: 100%;
      justify-content: space-between;
    }

    &-container._left {
      position: relative;
      @media (min-width: var.$size-md) {
        width: auto;
      }
    }

    &__mobile {
      display: flex;
      align-items: center;

      &__title {
        display: none;
        color: var.$secondary;
        margin-right: 10px;
      }

      &__sort {
        color: var.$black;
        cursor: pointer;
        position: relative;
        user-select: none;

        &.active + .serp-tours__sort__mobile__sort-arrow {
          transform: rotate(180deg);
        }

        &-wrapper {
          display: flex;
          align-items: center;
        }

        &-arrow {
          border-left: 5.5px solid transparent;
          border-right: 5.5px solid transparent;
          border-top: 5.5px solid #121212;
          margin-left: 5px;
        }
      }
    }

    &__dropdown {
      display: none;
      position: absolute;
      top: 25px;
      right: -1px;
      background: #fff;
      box-shadow: 1px 4px 20px rgb(153 153 169 / 35%);
      border-radius: 12px;
      padding: 8px;

      &.active {
        display: block;
        z-index: 2;
      }
    }

    &__button {
      color: var.$secondary;
      cursor: pointer;
      color: var.$black;
      padding: 11px 12px;
      border-radius: 6px;
      transform: all 200ms;

      &:hover {
        background: #f6f7fa;
      }
    }
  }

  &__view {
    display: flex;
    grid-gap: 16px;
    justify-content: flex-end;

    &-type {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 18px;
      letter-spacing: -0.02em;
      color: var.$secondary;
      grid-gap: 4px;
      display: flex;
      align-items: center;
      cursor: pointer;
    }
    &-type.active {
      color: var.$black;
    }
  }
  &__total {
    &-desktop {
      display: none;
    }
  }

  &__filters {
    grid-area: filter;
    width: 100%;
  }

  &__result {
    grid-area: tour;
    display: grid;
    grid-gap: 28px;
    width: 100%;
    height: fit-content;
    margin-top: 12px;

    &.empty {
      grid-template-columns: 1fr !important;
      width: 100% !important;
    }

    &__item {
      width: 100%;
    }

    &__empty {
      background: var.$white;
      border-radius: 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 100%;
      padding: 32px 0;

      &__header {
        font-size: 24px;
      }

      &__subheader {
        text-align: center;
        color: var.$secondary;
        margin: 16px 0 32px 0;
      }

      &__btn {
        box-shadow: unset !important;
      }
      &__buttons {
        align-items: center;
        justify-content: space-between;
        justify-items: center;
        .btn:first-child {
          margin-right: 0;
          margin-bottom: 16px;
        }
      }
    }
  }

  &__show-more {
    grid-area: more;
    margin: 20px 0;
    display: flex;
    justify-content: center;

    &__btn {
      width: 100%;
      box-shadow: unset;
      border-radius: 8px;
    }
  }

  &-seo-content {
    width: 100%;

    @media (min-width: var.$size-md) {
      grid-column-start: 1;
      grid-column-end: 4;
    }

    &__header {
      color: var.$violet-1;
      font-weight: 600;
      font-size: 13px;
      cursor: pointer;
      text-decoration: underline;

      &:hover {
        color: var.$violet-2;
      }
    }
    &__text {
      display: none;
      margin-top: 20px;

      &.active {
        display: block;
      }
    }
  }
}

.serp-banner__double {
    display: none;
}

@media (min-width: var.$size-sm) {

  .serp-tours__content {
    display: flex;
    justify-content: center;
  }

  .serp-tours__result {
    width: 408px;
    grid-template-columns: 408px;
  }
}

@media (min-width: var.$size-md) {
  .serp-tours__container {
    padding: 40px;
  }

  .serp-tours__filters {
    width: 292px;
    right: 0;
    left: unset;
  }

  .serp-tours__result {
    width: 100%;
    grid-gap: 24px;
    grid-template-columns: repeat(
      2,
      [col-start] minmax(275px, 500px) [col-end]
    );
    justify-items: center;

    &__empty {
      &__buttons {
        display: flex;

        .btn:first-child {
          margin-right: 16px;
          margin-bottom: 0;
        }
      }
    }
  }

  .serp-banner__double {
    display: flex;
    grid-area: 5/1/5/4;
    margin: 0 -12px;
    max-height: 156px;
  }
}

@media (min-width: var.$size-lg) {
  .serp-tours__content {
    width: 100%;
    max-width: 1176px;
    display: grid;
    grid-gap: 24px;
    align-items: unset;
    grid-template:
      [row1-start] "reset sort" auto [row1-end]
      [row2-start] "filter tour" auto [row2-end]
      [row3-start] ". more" auto [row3-end]
      / 1fr 3fr;
    justify-self: center;
  }

  .serp-tours__filters {
    display: block;
    height: min-content;
    width: 100%;
    min-width: 276px;
    max-width: 500px;
  }

  .serp-tours__result {
    grid-gap: 24px;
    margin-top: 0;

    &__empty {
      width: 100%;
      padding: 48px 0 56px 0;
    }
  }

  .serp-tours__reset {
    position: relative;
    padding-bottom: 0px;
    &._active {
      padding: 0;
      margin: 0;
    }

    &-item {
      display: none;
    }

    &-all {
      display: none;

      &-desktop {
        display: block;
      }
    }

    &__dropdown {
      display: flex;
      position: inherit;
      background: none;
      grid-gap: 24px;
      box-shadow: none;
    }
  }

  .serp-tours__sort {
    margin-top: 0;

    > * + * {
      margin-left: 24px;
    }

    &__mobile {
      &__title {
        display: block;
      }
    }

    &__dropdown {
      top: 25px;
      right: -15px;
      left: unset;
    }
  }

  .serp-tours__total {
    &-mobile {
      display: none;
    }

    &-desktop {
      display: block;
    }
  }
}

@media (min-width: var.$size-xl) {
  .serp-tours__result {
    grid-template-columns: repeat(
      3,
      [col-start] minmax(276px, 500px) [col-end]
    );
  }
}
</style>
